import React from 'react';

const checks = [
  { pillar: 'pricing', items: ['Benchmark LME actualizado', 'Yield y costes por categoría', 'Precio máximo con margen garantizado'] },
  { pillar: 'risk', items: ['Exposición total en tiempo real', 'Simulador de escenarios de mercado', 'Alertas configurables por metal'] },
];

export default function LandingPillars() {
  return (
    <section style={{ background: '#ffffff', padding: '100px 24px', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
      <div style={{ maxWidth: 1120, margin: '0 auto' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1px 1fr', gap: 0, alignItems: 'start' }} className="pillars-grid">
          {/* Pillar 1 — Pricing */}
          <div style={{ padding: '0 48px 0 0' }} className="pillar-col">
            <div style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: 56, fontWeight: 600, color: '#EA580C', lineHeight: 1, marginBottom: 24, opacity: 0.9 }}>01</div>
            <h2 style={{ fontSize: '1.75rem', fontWeight: 800, color: '#0f172a', letterSpacing: '-0.02em', marginBottom: 16, lineHeight: 1.2 }}>Motor de Pricing</h2>
            <p style={{ fontSize: '1rem', color: '#64748b', lineHeight: 1.7, marginBottom: 28 }}>
              Calcula al instante el precio máximo que puedes pagar por cada lote. Introduce el metal, el peso y el yield — MetalRecovery hace el resto: benchmark en tiempo real, costes, margen y buffer de riesgo.
            </p>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 12 }}>
              {checks?.[0]?.items?.map(item => (
                <li key={item} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <span style={{ width: 20, height: 20, borderRadius: '50%', background: '#fff7ed', border: '1.5px solid #fed7aa', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    <span style={{ color: '#EA580C', fontSize: 11, fontWeight: 800 }}>✓</span>
                  </span>
                  <span style={{ fontSize: 14, color: '#475569', fontWeight: 500 }}>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Vertical divider */}
          <div style={{ background: '#e2e8f0', alignSelf: 'stretch' }} className="pillar-divider" />

          {/* Pillar 2 — Risk */}
          <div style={{ padding: '0 0 0 48px' }} className="pillar-col">
            <div style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: 56, fontWeight: 600, color: '#EA580C', lineHeight: 1, marginBottom: 24, opacity: 0.9 }}>02</div>
            <h2 style={{ fontSize: '1.75rem', fontWeight: 800, color: '#0f172a', letterSpacing: '-0.02em', marginBottom: 16, lineHeight: 1.2 }}>Gestión del Riesgo</h2>
            <p style={{ fontSize: '1rem', color: '#64748b', lineHeight: 1.7, marginBottom: 28 }}>
              Controla la exposición de tu inventario en tiempo real. Simula escenarios de caída de mercado y recibe alertas automáticas cuando el riesgo supera tus límites.
            </p>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 12 }}>
              {checks?.[1]?.items?.map(item => (
                <li key={item} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <span style={{ width: 20, height: 20, borderRadius: '50%', background: '#fff7ed', border: '1.5px solid #fed7aa', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    <span style={{ color: '#EA580C', fontSize: 11, fontWeight: 800 }}>✓</span>
                  </span>
                  <span style={{ fontSize: 14, color: '#475569', fontWeight: 500 }}>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <style>{`
        @media (max-width: 768px) {
          .pillars-grid { grid-template-columns: 1fr !important; }
          .pillar-divider { display: none !important; }
          .pillar-col { padding: 0 0 48px !important; border-bottom: 1px solid #e2e8f0; }
          .pillar-col:last-child { border-bottom: none; padding-bottom: 0 !important; }
        }
      `}</style>
    </section>
  );
}
